var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faClose } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useRef, useState } from 'react';
import getTranslation from '../../strings/i18n';
import { RenderIf } from 'syf-component-library/ui/atoms';
import SlideInModalPortal from 'syf-component-library/ui/patterns/SlideInModalPortal/SlideInModalPortal';
import { ErrorBoundary } from 'syf-component-library/ui/templates';
import { getSelectPayAnalyticsProps } from '../../const/analytics/select-pay';
import { useActivityContext } from '../../context/activity-store';
import useSelectPayMutation from '../../hooks/use-select-pay-mutation';
import { StyledCloseButton, StyledPrimaryButton, StyledSecondaryButton } from '../../styles/buttons';
import InstallmentsHeader from './header';
import Installments from './installments';
import SelectPayComplete from './states/complete';
import SelectPayReviewInstallment from './states/review';
import { StyledTitle } from '../../styles/text';
import SelectPayModalState from '../../typings/select-pay/select-pay-types';
import { StyledModalActions, StyledModalHeader } from '../activity/modal/subcomponents';
import { CardHeader } from '../common/card-header';
import BusinessError from './states/business-error';
import SelectPayModalDefault from './states/default';
import SelectPayGenericError from './states/generic-error';
var SelectPayModal = function (_a) {
    var apiConfig = _a.apiConfig, closeModal = _a.closeModal, isModalOpen = _a.isModalOpen, transactions = _a.transactions;
    var isDisplayCondensed = useActivityContext().isDisplayCondensed;
    var t = getTranslation().t;
    var _b = useState(SelectPayModalState.default), currentModal = _b[0], setCurrentModal = _b[1];
    var _c = useState(), selectedTransaction = _c[0], setSelectedTransaction = _c[1];
    var _d = useState(), selectedPromotion = _d[0], setSelectedPromotion = _d[1];
    var _e = useState({}), mutationError = _e[0], setMutationError = _e[1];
    var modalTopRef = useRef(null);
    useEffect(function () {
        if (modalTopRef.current) {
            // Scroll to top of modal
            modalTopRef.current.scrollIntoView();
        }
    }, [currentModal]);
    var activeTransactionId = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.localTransactionId;
    var transactionOfferId = selectedTransaction === null || selectedTransaction === void 0 ? void 0 : selectedTransaction.transactionOfferId;
    var promotionalOfferId = selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.id;
    var selectPayMutation = useSelectPayMutation({
        apiConfig: apiConfig,
        transactionOfferId: transactionOfferId,
        promotionalOfferId: promotionalOfferId
    });
    var isDisabled = function () {
        if (selectPayMutation.isLoading ||
            (selectedTransaction === undefined &&
                SelectPayModalState.default === currentModal)) {
            return true;
        }
        return (selectedPromotion === undefined &&
            SelectPayModalState.installments === currentModal);
    };
    var handleSelectActivity = function (id) {
        transactions === null || transactions === void 0 ? void 0 : transactions.find(function (item) {
            if (item.localTransactionId === id) {
                return setSelectedTransaction(item);
            }
            return false;
        });
    };
    var handleConfirm = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, selectPayMutation.mutateAsync()];
                case 1:
                    _a.sent();
                    return [2 /*return*/, setCurrentModal(SelectPayModalState.complete)];
                case 2:
                    err_1 = _a.sent();
                    setCurrentModal(SelectPayModalState.error);
                    return [2 /*return*/, setMutationError(err_1)];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleSelectInstallment = function (installment) {
        setSelectedPromotion(installment);
    };
    var handleEscapeModal = function () {
        var handleResetModal = function () {
            setMutationError({});
            setCurrentModal(SelectPayModalState.default);
            setSelectedTransaction(undefined);
            setSelectedPromotion(undefined);
            if (isDisplayCondensed) {
                // Keep overflow hidden while Activity Preview modal is open
                document.body.style.overflow = 'hidden';
            }
        };
        var modalEl = document.getElementById('slide-in-select-pay-modal');
        modalEl === null || modalEl === void 0 ? void 0 : modalEl.addEventListener('transitioncancel', handleResetModal);
        modalEl === null || modalEl === void 0 ? void 0 : modalEl.addEventListener('transitionend', handleResetModal);
        closeModal();
    };
    var primaryActionHandler = function (action) {
        switch (action) {
            case SelectPayModalState.default:
                return {
                    action: function () { return setCurrentModal(SelectPayModalState.installments); },
                    analytics: getSelectPayAnalyticsProps({ targetName: 'continue' }),
                    text: t('selectPay.primaryDefaultButton')
                };
            case SelectPayModalState.installments:
                return {
                    action: function () { return setCurrentModal(SelectPayModalState.review); },
                    analytics: getSelectPayAnalyticsProps({
                        targetName: 'continue',
                        targetReason: selectedPromotion === null || selectedPromotion === void 0 ? void 0 : selectedPromotion.termLength
                    }),
                    text: t('selectPay.primaryInstallmentsButton')
                };
            case SelectPayModalState.review:
                return {
                    action: function () { return handleConfirm(); },
                    analytics: getSelectPayAnalyticsProps({
                        targetName: 'acceptOffer'
                    }),
                    text: t('selectPay.primaryReviewButton')
                };
            default:
                return {
                    action: function () { return handleEscapeModal(); },
                    analytics: getSelectPayAnalyticsProps({ targetName: 'close' }),
                    text: t('common.closeButton')
                };
        }
    };
    var secondaryActionHandler = function (action) {
        switch (action) {
            case SelectPayModalState.default:
                return {
                    action: function () { return closeModal(); },
                    analytics: getSelectPayAnalyticsProps({ targetName: 'back' }),
                    text: t('common.backButton')
                };
            case SelectPayModalState.installments:
                return {
                    action: function () { return setCurrentModal(SelectPayModalState.default); },
                    analytics: getSelectPayAnalyticsProps({
                        targetName: 'changeTransaction'
                    }),
                    text: t('selectPay.secondaryDefaultButton')
                };
            case SelectPayModalState.review:
                return {
                    action: function () { return setCurrentModal(SelectPayModalState.installments); },
                    analytics: getSelectPayAnalyticsProps({
                        targetName: 'changeSelection'
                    }),
                    text: t('selectPay.secondaryInstallmentsButton')
                };
            default:
                return { action: function () { }, analytics: {}, text: '' };
        }
    };
    var primaryAction = primaryActionHandler(currentModal);
    var secondaryAction = secondaryActionHandler(currentModal);
    return (_jsxs(SlideInModalPortal, { containerId: "mma-select-pay-modal-container", id: "slide-in-select-pay-modal", isOpen: isModalOpen, escapeModalHandler: handleEscapeModal, header: _jsxs(StyledModalHeader, { alignItems: "center", justifyContent: "space-between", children: [_jsx(StyledTitle, { children: t('selectPay.brandHeading') }), _jsx(StyledCloseButton, __assign({ onClick: handleEscapeModal, "aria-label": "close" }, getSelectPayAnalyticsProps({ targetName: 'xButton' }), { children: _jsx(FontAwesomeIcon, { icon: faClose, size: "1x" }) }))] }), footer: _jsxs(StyledModalActions, { justifyContent: "end", alignItems: "center", children: [_jsx(RenderIf, { condition: secondaryAction.text.length > 0, children: _jsx(StyledSecondaryButton, __assign({ onClick: secondaryAction.action, uppercase: true }, secondaryAction.analytics, { children: secondaryAction.text })) }), _jsx(StyledPrimaryButton, __assign({ disabled: isDisabled(), onClick: primaryAction.action }, primaryAction.analytics, { children: primaryAction.text }))] }), children: [_jsx("div", { ref: modalTopRef }), _jsx(RenderIf, { condition: Boolean(selectedTransaction && ((mutationError === null || mutationError === void 0 ? void 0 : mutationError.code) || (mutationError === null || mutationError === void 0 ? void 0 : mutationError.name))), children: _jsx(BusinessError, { error: mutationError, selectedTransaction: selectedTransaction }) }), _jsx(RenderIf, { condition: currentModal === SelectPayModalState.default, children: _jsx(ErrorBoundary, { fallback: _jsx(SelectPayGenericError, {}), children: _jsx(SelectPayModalDefault, { activeTransactionId: activeTransactionId, transactions: transactions, handleSelectActivity: handleSelectActivity }) }) }), _jsx(RenderIf, { condition: currentModal === SelectPayModalState.installments ||
                    currentModal === SelectPayModalState.review, children: _jsxs(_Fragment, { children: [_jsx(CardHeader, {}), selectedTransaction && (_jsx(InstallmentsHeader, { selectedTransaction: selectedTransaction })), _jsx(RenderIf, { condition: currentModal === SelectPayModalState.installments, children: _jsx(ErrorBoundary, { fallback: _jsx(SelectPayGenericError, {}), children: _jsx(Installments, { selectedPromotion: selectedPromotion, selectedTransaction: selectedTransaction, onSelectInstallment: handleSelectInstallment }) }) }), selectedPromotion &&
                            selectedTransaction &&
                            currentModal === SelectPayModalState.review && (_jsx(SelectPayReviewInstallment, { installment: selectedPromotion }))] }) }), _jsx(RenderIf, { condition: currentModal === SelectPayModalState.complete, children: _jsxs(_Fragment, { children: [_jsx(CardHeader, {}), _jsx(ErrorBoundary, { fallback: _jsx(SelectPayGenericError, {}), children: _jsx(SelectPayComplete, { selectedPromotion: selectedPromotion, selectedTransaction: selectedTransaction }) })] }) })] }));
};
export default SelectPayModal;
//# sourceMappingURL=index.js.map